import apiClient from '../middleware/apiClient';
import { COTTON_HIC, HIC } from '../helpers/apis';
import { callApiWithFallback } from '../helpers/apiFallback';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { kibanaLog } from '../helpers/logger';

export const GET_HIC = 'GET_HIC';
export const GET_HIC_SUCCESS = 'GET_HIC_SUCCESS';
export const GET_HIC_FAILURE = 'GET_HIC_FAILURE';

function dispatchGetHic(endpoint = HIC) {
  return {
    type: GET_HIC,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetHicSuccess(data) {
  return {
    type: GET_HIC_SUCCESS,
    payload: data,
  };
}

function dispatchGetHicFailure(error) {
  return {
    type: GET_HIC_FAILURE,
    payload: error,
  };
}

export const getHic = () => async (dispatch, getState) => {
  const { hic = {} } = getState();
  if (hic.requested) {
    return null;
  }

  try {
    let response;
    const { isAptV1Enabled, hicEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      // Use APT V1 API (100% Kotlin)
      kibanaLog('cotton_hic_api_called');
      response = await dispatch(dispatchGetHic(COTTON_HIC)).payload;
    } else if (hicEnabled) {
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => dispatchGetHic(COTTON_HIC),
        () => dispatchGetHic(HIC),
        'hic',
      );
    } else {
      // Only call Ruby API
      response = await dispatch(dispatchGetHic(HIC)).payload;
    }

    return dispatch(dispatchGetHicSuccess(response));
  } catch (error) {
    return dispatch(dispatchGetHicFailure(error));
  }
};
